var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_903)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.923218H24V17.0247H0V0.923218Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 10.8551H9.47789V17.0244H5.73914V10.8551H0V7.09212H5.73914V0.922913H9.47789V7.09212H24V9.97988V10.8551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 7.9674V9.97988H8.60869V17.0244H6.60834V9.97988H0V7.9674H6.60834V0.922913H8.60869V7.9674H24Z",
    fill: "#2E52B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16.1013,
    fill: "white",
    transform: "translate(0 0.923096)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/NO.a62af6e15ff6b7e872ed787b4775e0ba.svg";
export { ForwardRef as ReactComponent };